import useIsExcludedExternalOperatorScope from '../hooks/useIsExcludedExternalOperatorScope';
import { ErrorPage } from '@/pages/Layout/pages';
import { LoaderBackdrop } from '@/components';
import { Outlet } from 'react-router-dom';

const BusinessExternalOperatorsScopeGuard = () => {
  const { isExcludedOperatorScope, isLoading } =
    useIsExcludedExternalOperatorScope();

  if (isLoading) return <LoaderBackdrop />;

  if (isExcludedOperatorScope) {
    return <ErrorPage code={403} />;
  }

  return <Outlet />;
};

export default BusinessExternalOperatorsScopeGuard;
